import { FC, useEffect, useState } from 'react';
import { TableBody as Body } from '@mui/material';

import { TableNoData } from '../../../../../shared/uiComponents';
import { HeaderProperties } from '../../../../../shared/uiComponents/Table/tableProperties';
import Row from './targetRow';

import { TargetProperties } from '../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';

interface RowRendererProperties {
	data: TargetProperties[];
}

export interface RowStateProperties {
	id: string;
	open: boolean;
}

export const TargetHeader: HeaderProperties[] = [
	{ id: '9', name: 'Target Name', width: '250px' },
	{ id: '1', name: 'Status' },
	{ id: '2', name: 'Response Rate' },
	{ id: '3', name: 'Opened' },
	{ id: '4', name: 'Mastered' },
	{ id: '5', name: 'Type' },
	{ id: '6', name: 'Mast. Type' },
	{ id: '7', name: 'Cons. Days' },
	{ id: '8', name: '' },
];

export const TargetBody: FC<RowRendererProperties> = ({ data }) => {
	const [rowOpenStates, setRowOpenStates] = useState<RowStateProperties[]>([]);

	useEffect(() => {
		if (!data?.length) return;

		setRowOpenStates((prev) =>
			data.map((item) => {
				const existing = prev.find((row) => row.id === item.id);

				return { id: item.id, open: existing?.open ?? false };
			}),
		);
	}, [data]);

	if (!data?.length) {
		return <TableNoData spanScope={TargetHeader.length} />;
	}

	return (
		<Body>
			{Boolean(data) &&
				data.map((item, index) => (
					<Row
						item={item}
						key={item.id}
						rowStates={rowOpenStates}
						setRowStates={setRowOpenStates}
						allTargets={data}
						currentIndex={index}
					/>
				))}
		</Body>
	);
};
